import type { User } from "./types";

const SITE_RESOURCE_TYPE = "SITE";
const ALL = "*";

// User 객체는 zustand store 의 불변 객체라 권한 변경 시에만 참조가 바뀐다.
// 목록 필터링에서 canAccessSite 가 현장 수(최대 1000)만큼 반복 호출되므로
// User 별 계산 결과를 WeakMap 으로 캐시해 O(N×M) 재계산을 방지한다.
const siteIdsCache = new WeakMap<User, Set<string>>();

export function getSiteIds(user: User | null): Set<string> {
  if (!user) return new Set<string>();
  const cached = siteIdsCache.get(user);
  if (cached) return cached;

  const ids = new Set<string>();
  for (const p of user.permissions ?? []) {
    for (const rp of p.resourcePermissions ?? []) {
      if (rp.resourceType === SITE_RESOURCE_TYPE && rp.resourceId) ids.add(rp.resourceId);
    }
  }
  siteIdsCache.set(user, ids);
  return ids;
}

export function canAccessSite(user: User | null, siteId: string | number): boolean {
  if (!user) return false;
  if (user.authority === "ADMIN") return true;
  const ids = getSiteIds(user);
  return ids.has(ALL) || ids.has(String(siteId));
}

export function hasNoSiteAccess(user: User | null): boolean {
  if (!user) return true;
  if (user.authority === "ADMIN") return false;
  const ids = getSiteIds(user);
  return !ids.has(ALL) && ids.size === 0;
}
